import { useQuery } from '@tanstack/react-query';
import request from '@/services/api';

export const useExamList = (params?: any) => {
  return useQuery({
    queryKey: ['exam-list', params],
    queryFn: async () => {
      const res = await request.get('/exam', { params });
      return res.data;
    }
  });
};

export const useExamGet = (id?: string) => {
  return useQuery({
    queryKey: ['exam-get', id],
    queryFn: async () => {
      if (!id) return null;
      const res = await request.get(`/exam/${id}`);
      return res.data;
    },
    enabled: !!id,
  });
};

export const useExamQuestionsList = (params: { testId: string; pageNumber?: number; pageSize?: number }) => {
  return useQuery({
    queryKey: ['exam-questions-list', params],
    queryFn: async () => {
      const res = await request.get('/exam/questions', { params });
      return res.data;
    },
    enabled: !!params.testId,
  });
};
